/* global gtag_report_conversion */
import React, { useEffect, useState } from "react";

import "../styles/footer.css";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="custom-footer py-5">
      <div className="container">
        <div className="row text-center justify-content-center">
          {/* Address Column */}
          <div className="col-md-4 mb-4 mb-md-0 d-flex flex-column align-items-center">
            <div className="map-responsive">
              <iframe
                title="Szolnok cím"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d33056.45331799574!2d20.1706804!3d47.1710853!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47414105184f45a9%3A0x44136c8f4dd7bcd2!2sOlajcsere%20Szolnok%20%F0%9F%94%A7%20Dkraft%20aut%C3%B3szerv%C3%ADz%20Szolnok!5e1!3m2!1shu!2shu!4v1756104902753!5m2!1shu!2shu"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Call Column */}
          <div className="col-md-4 mb-4 mb-md-0 d-flex flex-column justify-content-center align-items-center">
            <h5 className="footer-title">Foglalj időpontot!</h5>
            <a
              href="tel:+36300167381"
              onClick={(e) => {
                try {
                  if (typeof gtag_report_conversion === "function") {
                    gtag_report_conversion("tel:+36300167381");
                  }
                } catch (err) {
                  console.error("gtag_report_conversion error:", err);
                }
              }}
              className="footer-phone-btn"
            >
              +36 30 016 7381
            </a>

            <p className="footer-address mb-1 pt-4">
              5000 Szolnok, Véső utca 1.
            </p>
            <p className="footer-hours">H-P: 08:00-16:00 Sz-V: Zárva</p>
          </div>
          {/* Social & Links Column */}
          <div className="col-md-4 d-flex flex-column justify-content-center align-items-center">
            <div className="footer-socials mb-3">
              <a href="https://www.facebook.com/people/DKraft-Diesel-Garage-Aut%C3%B3szerviz/61576046091214/">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/dkraft.hu/#">
                <FaInstagram />
              </a>
            </div>
            <a href="/impresszum" className="footer-link">
              Impresszum
            </a>
            <a href="/adatvedelem" className="footer-link mt-2">
              Adatkezelési tájékoztató
            </a>
          </div>
        </div>

        <div className="text-center text-company small">
          © {new Date().getFullYear()} Ratkai Technologies Kft. Minden jog
          fenntartva.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
